export default __webpack_public_path__ + "static/media/flag.c754c87b.svg";